import {
  COMPANY_NAME
} from "../const";

export const feedbackFormSubject = {
  getTemplate(subject) {
    return `<input type="hidden" name="request-subject" value="${COMPANY_NAME} – ${subject}">`;
  }
};
